import fetch from "@/util/resources/fetch";
import locale from "@/util/resources/locale";

export default {
  fetch,
  locale,
};
